import {
  getUpdaterOrValue,
  reduceColumnFilters,
  reduceSorting,
} from "@/shared/utils/data-table";
import type { ColumnFiltersState, SortingState } from "@tanstack/react-table";
import { create } from "zustand";

export interface FiltersStore {
  globalFilter: string;
  setGlobalFilter: (updater: string | ((old: string) => string)) => void;
  columnFilters: ColumnFiltersState;
  setColumnFilters: (
    updater:
      | ColumnFiltersState
      | ((old: ColumnFiltersState) => ColumnFiltersState),
  ) => void;
  sorting: SortingState;
  setSorting: (
    updater: SortingState | ((old: SortingState) => SortingState),
  ) => void;
}

export const useDynamicFiltersStoreBuilder = () =>
  create<FiltersStore>((set) => ({
    globalFilter: "",
    setGlobalFilter: (updater) =>
      set((state) => {
        const value = getUpdaterOrValue({
          updaterOrValue: updater,
          old: state.globalFilter,
        });
        return { globalFilter: value };
      }),
    columnFilters: [],
    setColumnFilters: (updater) =>
      set((state) => {
        const value = getUpdaterOrValue({
          updaterOrValue: updater,
          old: state.columnFilters,
        });

        if (!Array.isArray(value)) {
          return { columnFilters: state.columnFilters };
        }

        return { columnFilters: reduceColumnFilters(value) };
      }),
    sorting: [],
    setSorting: (updater) =>
      set((state) => {
        const value = getUpdaterOrValue({
          updaterOrValue: updater,
          old: state.sorting,
        });

        if (!Array.isArray(value)) {
          return { sorting: state.sorting };
        }

        return { sorting: reduceSorting(value) };
      }),
  }));
